<template>
  <div>
    <!-- about us page -->
    <h1>About us</h1>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
